import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/site/Primitives";

export default function AuthCallback() {
  const { hash } = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => { setUser(data); nav("/admin", { replace: true, state: { user: data } }); })
      .catch((e) => setError(errMsg(e)));
  }, [hash, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] p-6" data-testid="auth-callback">
      {error ? (
        <div className="max-w-md text-center space-y-4">
          <p className="text-[#FF3B30]" data-testid="auth-callback-error">{error}</p>
          <a href="/admin/login" className="eb-btn-ghost">Back to sign-in</a>
        </div>
      ) : <p className="flex items-center gap-2 text-zinc-400"><Spinner />Signing you in</p>}
    </div>
  );
}
